import {
  Box,
  Button,
  Checkbox,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  LinearProgress,
  Modal,
  Backdrop,
  Fade,
} from "@mui/material";
import React, { useState } from "react";
import CustomInput from "../../Components/Common/CustomInput";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo/slogo.svg";
import { useDispatch, useSelector } from "react-redux";
import { LOGIN_MUTATION } from "../../Utils/Mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import { setUser } from "../../store/userSlice";
import { PiEyeClosedBold } from "react-icons/pi";
import { GiAngryEyes } from "react-icons/gi";
import { useSnackbarHook } from "../../hooks/useSnackbarHook";
import { GET_USER_PERMISSIONS } from "../../Utils/Queries";
import { GrSettingsOption } from "react-icons/gr";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

const Login = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { handleClick } = useSnackbarHook();
  const [showPassword, setShowPassword] = React.useState(false);
  const [loginMutation, { loading, error }] = useMutation(LOGIN_MUTATION);

  const [getUserPermissions, { loading: userLoading }] = useLazyQuery(
    GET_USER_PERMISSIONS,
    {
      fetchPolicy: "network-only",
    }
  );

  const handleGetPermissions = async () => {
    await getUserPermissions()
      .then((res) => {
        localStorage.setItem(
          "user_permission",
          JSON.stringify(res?.data?.getAdminRolePermissions)
        );
        handleClose();
        navigate("/");
      })
      .catch((err) => {
        handleClick(`${err?.message}`, "error");
      });
  };

  const handleLogin = async () => {
    try {
      const { data } = await loginMutation({
        variables: { email, password },
      });
      dispatch(setUser(data?.loginAdmin));
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("mamaketUserToken", data?.loginAdmin?.accessToken);
      handleOpen();
      setTimeout(() => {
        handleGetPermissions();
      }, 2000);

      // navigate("/");
    } catch (error) {
      handleClick(`${error?.message}`, "error");
    }
  };
  return (
    <>
      <Box sx={{ height: "100vh", display: "grid", placeItems: "center" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
              <img src={logo} width={20} />
              <Box>
                <Typography sx={{ fontWeight: 900, fontSize: "26px" }}>
                  Ma
                </Typography>
              </Box>
            </Box>
            <Typography sx={{ textAlign: "center", fontWeight: 900, mt: 1 }}>
              Mamaket Workplace
            </Typography>
          </Box>
          <Box
            sx={{
              width: {md:"30%", xs:"90%"},
              border: "1px solid #E6E6E6",
              
              p: 4,
              boxSizing: "border-box",
              bgcolor: "#fff",
              borderRadius: "4px",
            }}
          >
            {loading && <LinearProgress sx={{ mb: 2 }} />}
            <Typography variant="h3">Welcome </Typography>
            <Typography variant="body1">Please enter your detail</Typography>
            <Box sx={{ mt: 5 }}>
              <CustomInput
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                label="Email"
                placeholder="Email Address"
              />
              <TextField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                type={showPassword ? "text" : "password"}
                size="large"
                fullWidth
                InputProps={{
                  style: {
                    //   fontFamily: "Gordita",
                    marginTop: "10px",
                    marginBottom: "20px",
                    fontSize: "13px",
                    borderRadius: "8px",
                    offset: " 1px solid #f2f2f2",
                    // Replace with your desired font family
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? (
                          <GiAngryEyes
                            style={{ fontSize: "26px", color: "#333" }}
                          />
                        ) : (
                          <PiEyeClosedBold
                            style={{ fontSize: "20px", color: "#333" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: 2,
                  }}
                >
                  <Checkbox /> <Typography>Remember me</Typography>
                </Box>
                <Link to="">
                  <Typography variant="h5">Forget Password?</Typography>
                </Link>
              </Box>

              <Button
                disabled={loading || !email || !password}
                onClick={handleLogin}
                variant="contained"
                fullWidth
                sx={{ mt: 4, borderRadius: "100px" }}
                size="large"
              >
                Sign in
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box align="center">
              <div className="spinning-icon">
                <GrSettingsOption style={{ fontSize: "40px" }} />
              </div>

              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  textAlign: "center",
                  mt: 2,
                }}
              >
                Setting up your workplace...
              </Typography>
              <LinearProgress sx={{ mt: 1, height: "1px" }} />
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default Login;
